











 













const node = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "teamId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddSlackAuthMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SlackNotificationList_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SlackProviderRow_viewer"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "teamId",
              "variableName": "teamId"
            }
          ],
          "concreteType": "TeamMember",
          "kind": "LinkedField",
          "name": "teamMember",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StageTimerModalEndTimeSlackToggle_facilitator"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AddSlackAuthPayload",
  "abstractKey": null
};

(node ).hash = "4d9d773324cd743a75ca3e9b9892d667";

export default node;
